import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTraffic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.375 18.25C5.82475 18.25 7 17.0747 7 15.625C7 14.1753 5.82475 13 4.375 13C2.92525 13 1.75 14.1753 1.75 15.625C1.75 17.0747 2.92525 18.25 4.375 18.25Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.625 6.99976C17.0747 6.99976 18.25 5.8245 18.25 4.37476C18.25 2.92501 17.0747 1.74976 15.625 1.74976C14.1753 1.74976 13 2.92501 13 4.37476C13 5.8245 14.1753 6.99976 15.625 6.99976Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.375 6.99976C5.82475 6.99976 7 5.8245 7 4.37476C7 2.92501 5.82475 1.74976 4.375 1.74976C2.92525 1.74976 1.75 2.92501 1.75 4.37476C1.75 5.8245 2.92525 6.99976 4.375 6.99976Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.375 13V12.25C4.37501 11.6533 4.61206 11.081 5.03401 10.6591C5.45596 10.2371 6.02824 10.0001 6.62495 10.0001L13.375 9.99993C13.9718 9.99993 14.544 9.76289 14.966 9.34095C15.3879 8.91901 15.625 8.34673 15.625 7.75002V7",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.375 7V13",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTraffic;
